import React, { useEffect, useReducer, useState } from 'react';
import { ListItemLayout, ListLayout, Pager, Searchfield, SkillLevel, colourString, useMatchScreenWidth } from '@keplerco/core';
import { IViewRoleSkillsWidgetProps } from '../view-role.models';
import styles from './view-role-skills.module.css';
import classNames from 'classnames';
import { EntitiesCard } from '../../../../components/entities-card.widget';
import { EmptyState } from '../../../../components/empty-state/empty-state';
import { themedAssetUrl } from '../../../../theme-asset-url';
import { DefaultOptions, useApis } from '../../../../global-state';
import { SkillDto } from '../../../../apis';

export default function ViewRoleSkillsWidget({ role }: IViewRoleSkillsWidgetProps) {
  const isMobile = useMatchScreenWidth('mobile');
  const { skillApi } = useApis();
  const [designations, setDesignations] = useState(role?.designations || []);

  useEffect(() => {
    if (role?.designations) {
      Promise.all(
        role.designations.map(async (designation) => {
          if (!designation.skills?.length) {
            const skills = await skillApi.skillSuggestGet(designation.id, DefaultOptions);
            return { ...designation, skills };
          }
          return designation;
        })
      ).then(updatedDesignations => {
        setDesignations(updatedDesignations);
      });
    }
  }, [role, skillApi]);
  return (
    <>
      <span className="caption1">{`These are different career levels for ${role?.name}, from entry to expert.`}</span>

      {designations?.length > 0 ? (
        designations?.map(designation => {
          let skills: Array<SkillDto> = []
          if (designation?.skills != undefined && designation?.skills?.length > 0) {
            skills = designation.skills;
          }
          return <EntitiesCard title={designation.name!} description={designation.description!}>
            <div style={{ minHeight: 370, marginTop: 15, marginBottom: 0 }}>
              
              {skills.length > 0 ? (
                <ListLayout>
                  
                  <span className="caption1">Important skills for the role:</span>
                  {skills.map((skill) => (
                    <ListItemLayout key={skill.id}>
                      <div className={classNames('card', styles.skillCard)} style={{ gridTemplateColumns: (skill.level !== null && !isMobile) ? 'minmax(0px, 1fr) auto' : '1fr' }}>
                        <div style={{ overflow: 'hidden' }}>
                          <h5 className={classNames('heading5', styles.skillCardText)} style={{ color: colourString('lilac') }}>{skill.name}</h5>
                          <p className={classNames('caption2', styles.skillCardText)}>{skill.description}</p>
                        </div>

                        {skill.level !== null && (
                          <SkillLevel
                            level={skill.level ?? 0}
                            minLevel={0}
                            maxLevel={6}
                            notAssessed={false}
                            title="Expected proficiency"
                            dotColour={'baby-blue'}
                          />
                        )}
                      </div>
                    </ListItemLayout>
                  ))}
                </ListLayout>
              ) : (
                <EmptyState
                  badgeUrl={themedAssetUrl('graphics/empty-state-clouds.graphic.svg')}
                  badgeIconWidth="full-width"
                  subtitle="No skills found"
                  centerText
                />
              )}
            </div>
          </EntitiesCard>
        })
      ) : (
        <EmptyState
          badgeUrl={themedAssetUrl('graphics/empty-state-clouds.graphic.svg')}
          badgeIconWidth="full-width"
          subtitle="No designations found"
          centerText
        />
      )}
    </>
  );
}
